export default {
    router18: {
        app: '应用',
        create: '创造',
        interface: '接入',
        openInterface: '应用接入',
        createApp: '创建应用',
        agent: '应用配置',
        manage: '管理',
        myAccount: '我的账户',
        chatManage: '对话管理',
        clients: '客户端',
        dataAnalysis: '数据看板',
        configurationClient: '客户端配置',
        knowledgeBase: '知识库',
        fileManage: '文件管理',
        fileImport: '文件导入',
        retrievalTest: '检索测试',
        knowledgeBaseConfig: '知识库配置',
        mediaResource: '素材管理',
        database: '数据库',
        dataPreview: '数据预览',
        tableConfig: '数据表配置',
        databaseConfig: '数据库配置',
        plugins: '插件',
        discovery: '发现',
        templateCenter: '模板中心',
        templateDetail: '模板详情',
        workflow: '工作流',
        customPlugin: '自定义插件',
        teamSpace: '团队空间',
        purchase: '购买',
        customerManage: '客户管理',
        customerList: '客户列表',
        tagList: '标签管理'
    }
}   